import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import user from './modules/user';
import account from './modules/account';
import device from './modules/device';
import vehicle from './modules/vehicle';
import dashboard from './modules/dashboard';
import sim from './modules/sim';
import notification from './modules/notification';
import language from './modules/language';
import dtMapping from './modules/dtMapping';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    account,
    device,
    vehicle,
    sim,
    dashboard,
    notification,
    language,
    dtMapping
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js